export default "__VITE_ASSET__DPelbkiX__"